import axios from 'axios';
import sanitize from 'sanitize-html';
import { container } from '../../diContainer';
import { NotificationLevel, ToastNotification } from '../modules/notifications/models/notification.model';
import { INotificationsService } from '../modules/notifications/services/notifications.service';

/**
 * Download file using <a> element. It prevents browsers from blocking the download treating
 * it as popup window.
 */
async function downloadFile(fileUrl: string): Promise<void> {
  const a = document.createElement('a');
  a.id = fileUrl;
  a.href = sanitize(fileUrl);
  a.download = '';

  document.body.appendChild(a);

  a.click();
  a.parentNode?.removeChild(a);

  // Arbitrary wait time to prevent multiple downloads from cancelling each other
  await new Promise((resolve) => {
    setTimeout(resolve, 2000);
  });
}

export async function downloadFileWithCheck(fileUrl: string): Promise<void> {
  const showError = async (): Promise<void> => {
    await container.get(INotificationsService.$).push(new ToastNotification(NotificationLevel.ERROR, 'failed_to_download'));
  };

  try {
    const response = await axios(fileUrl, { method: 'HEAD' });
    if (response.status !== 200) {
      throw new Error('File might not be available');
    }

    await downloadFile(fileUrl);
  } catch {
    await showError();
  }
}
